import type { IconData } from '@stacksjs/iconify-core'

export const cn1x1: IconData = {
  "body": "<defs><path id=\"SVG0MuIu9fr\" fill=\"#ff0\" d=\"M1-.3L-.7.8L0-1L.6.8L-1-.3z\"/></defs><path fill=\"#ee1c25\" d=\"M0 0h512v512H0z\"/><use width=\"30\" height=\"20\" href=\"#SVG0MuIu9fr\" transform=\"translate(128 128)scale(76.8)\"/><use width=\"30\" height=\"20\" href=\"#SVG0MuIu9fr\" transform=\"rotate(-121 142.6 -47)scale(25.5827)\"/><use width=\"30\" height=\"20\" href=\"#SVG0MuIu9fr\" transform=\"rotate(-98.1 198 -82)scale(25.6)\"/><use width=\"30\" height=\"20\" href=\"#SVG0MuIu9fr\" transform=\"rotate(-74 272.4 -114)scale(25.6137)\"/><use width=\"30\" height=\"20\" href=\"#SVG0MuIu9fr\" transform=\"matrix(16 -19.968 19.968 16 256 230.4)\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cn1x1
